/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Frame_Rate_HelpInputs */



/**
* | output |
* | --- |
* | "Select the frame rate of your source material" |
*
* @param {Source_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_frame_rate_help = /** @type {((inputs?: Source_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez la fréquence d’images de votre source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Bildrate Ihres Quellmaterials.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il frame rate del materiale sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите частоту кадров исходного материала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione la velocidad de fotogramas de su material de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择源素材的帧速率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース素材のフレームレートを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने स्रोत सामग्री की फ्रेम दर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a taxa de quadros do seu material de origem.")
	return /** @type {LocalizedString} */ ("Select the frame rate of your source material")
});